module.exports = __webpack_public_path__ + "static/media/Carolina-oval.1f762587.jpg";